// extracted by mini-css-extract-plugin
export default {"checklist__item":"styles_checklist__item__P5gck"};